import { useEffect, useState } from "react";
import { api, type Me } from "./api";
import { useAuth } from "./useAuth";

// Module-level cache: /me is stable for a given uid, no need to refetch on
// every mount (Layout + Authoring both consume the hook).
let cachedUid: string | null = null;
let cachedPromise: Promise<Me> | null = null;

export function useMe(): { me: Me | null; loading: boolean } {
  const { user } = useAuth();
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      cachedUid = null;
      cachedPromise = null;
      setMe(null);
      setLoading(false);
      return;
    }
    if (cachedUid !== user.uid || !cachedPromise) {
      cachedUid = user.uid;
      cachedPromise = api.me();
    }
    let cancelled = false;
    setLoading(true);
    cachedPromise
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch(() => {
        if (!cancelled) setMe(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  return { me, loading };
}
